<template>
    <div v-if="IsAuthenticated" id="eventDeck">
        <wkb-help></wkb-help>
        <message v-if="IsHeatsLoading">
            <div class="center"><loader></loader></div>
        </message>
        <message v-if="!HasEventData && !IsHeatsLoading" :text="$t('text.noData')"></message>
        <div class="f-column" v-if="HasEventData">
            <div class="event-wrapper f-row f-wrap" v-if="!isEventOpen && !isSettings">
                <event-card v-for="(event, i) in EventData" v-bind:key="i" :event="event"></event-card>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>

import { mapMutations, mapActions, mapGetters } from 'vuex';
import glAct from '../store/actions/global';
import glMut from '../store/mutations/global';
import navMutations from '../store/mutations/navigation';

import EventCard from './EventCard.vue';
import Message from './Message.vue';
import WkbHelp from './WKBHelp.vue';
import Loader from './Loader'

import * as signalR from '@aspnet/signalr';

export default {
    name: "event-deck",
    data: function() {
        return {
            shl: {
                name: "SendHeatList",
                method: (data) => {
                    this.SETHEATS(data.heats);
                    if(this.SelectedCompetition === ""){                    
                        this.SETSELECTEDCOMPETITION({id: data.id, name: data.name, town: data.town, date: data.date, nation: data.nation });
                    }
                }
            },  
            scl: {
                name: "SendCompetitionList",
                method: (data) => {
                    if(this.SelectedCompetition && !data.find(c => c.id === this.SelectedCompetition.id)){
                        console.log("DELETED!!");
                    }
                }
            }
        }
    },
    components: {
        EventCard,
        Message,
        WkbHelp,
        Loader,
    },
    computed: {     
        ...mapGetters(['Events', 'ConnectionState', 'SelectedCompetition', 'IsAuthenticated', 'SelectedHeat', 'IsHeatsLoading']),    
        EventData () {
            if(!!this.Events)
                return this.Events.filter(x => x.state != 3 && !x.disabled);
            return [];
        },
        HasEventData (){
            return this.EventData.length != 0;
        },
        isEventOpen () {
            return this.$route.path.includes('/event/');
        },
        isSettings () {
            return this.$route.path.includes('/settings');
        }
    },
    methods: {
        ...mapMutations([glMut.SETHEATS,
            glMut.SETSELECTEDCOMPETITION,
            glMut.REGISTERHUB,
            glMut.UNREGISTERHUB,,
            navMutations.SHOWNAVPOINT,
            navMutations.HIDEALLNAVPOINT
        ]),     
        ...mapActions([
            glAct.GETHEATS,
            glAct.SENDHEATGROUP
        ]),  
        registerMethods(){
            this.REGISTERHUB(this.shl);
            this.REGISTERHUB(this.scl);

            this.GETHEATS();
        },
        unregisterMethods(){
            this.UNREGISTERHUB(this.shl);
            this.UNREGISTERHUB(this.scl);
        },
        updateCachedHeats(){
            if(this.Events) 
                this.Events.forEach(h => {
                    if (h.id == this.SelectedHeat.id) {
                        const heat = JSON.parse(localStorage.getItem(h.id))
                        if(heat && heat.dirty) {
                            this.SENDHEATGROUP(heat.heat)
                        }
                    }
                });
        }
    },
    watch: {
        ConnectionState(n, o){
            if(n === 1 && n != o) {
                if(o === 0) this.registerMethods();
                this.updateCachedHeats();
            }
            else if(n === 0){
                this.unregisterMethods();
            }
        }
    },
	created(){
        if(this.ConnectionState !== 0){
            this.registerMethods();
        }
        else{
            const ev = JSON.parse(localStorage.getItem('heats'));
            if(ev && ev.length != 0) {
                this.SETHEATS(ev);
            }
        }
    },
    mounted(){        
        this.SHOWNAVPOINT([0, 3, 7]);
    },
    beforeDestroy(){
        this.HIDEALLNAVPOINT();
        this.unregisterMethods();
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .event-wrapper {
        height:0px;
    }
</style>